// Clear sessionToken from localStorage on page refresh/load
try {
  localStorage.removeItem("sessionToken");
} catch (e) {
  console.error("Failed to clear sessionToken on load:", e);
}

export const getStoredValue = <T>(key: string): T | null => {
  const raw = localStorage.getItem(key);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

export const setStoredValue = (key: string, value: unknown): void => {
  const encoded = JSON.stringify(value);
  localStorage.setItem(key, encoded);
};